import { newbornData } from '../lib/data';
import styles from './Newborn.module.scss';

const Newborn = () => {

    return ( 
        <section >
                <div className = {styles.container}>  
                    {newbornData.map(({id, photo}) => (
                        <div className = {styles.container__photo} key={id}> 
                        <img  className={styles.photo} src={photo} alt="newborn фото Ставрополь"/>
                        </div>
                    ))}
                </div>
        </section>
    );
}
export default Newborn;